<template>
    <InventoryLevelManager />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InventoryLevelManager from '@/components/inventory/InventoryLevelManager.vue';

export default defineComponent({
    name: 'MngInventory2',
    components: {
        InventoryLevelManager,
    },
});
</script> 